import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { EllipsisOutlined } from '@ant-design/icons';
import { Menu, Dropdown } from 'antd';
import classNames from 'classnames';
import styles from '../Annotation.module.scss';
import { RootState } from '../../../../rootReducer';
import { AppDispatch } from '../../../../store';
import { publishSingleTurbine } from '../annotation.slice';
import DataQCAssessmentModal from './QC/DataQCAssessmentModal';
import { createTurbineDataQCAssessment } from './QC/qc.slice';
import PublishModal from '../../../Shared/Landing/PublishModal';
import { PublishRequest } from '../../../Shared/Landing/Landing.slice';

type Props = { turbinePath: string } & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const MenuOptions = {
  Publish: 'publish',
  QCAssessment: 'qcAssessment'
};

export const TurbineActions: FC<Props> = ({
  isPublishing,
  turbinePath,
  turbineDataQCAssessment,
  loadingDataQCAssessment,
  creatingDataQCAssessment,
  canAnnotate,
  canPublish,
  standard,
  onPublishAnnotations,
  onCreateTurbineDataQCAssessment
}) => {
  const [showQCAssessmentDialog, setShowQCAssessmentDialog] = useState(false);
  const [showPulishModal, setShowPublishModal] = useState(false);

  const onClick = (item: any) => {
    switch (item.key) {
      case MenuOptions.Publish:
        setShowPublishModal(true);
        break;
      case MenuOptions.QCAssessment:
        setShowQCAssessmentDialog(true);
        break;
      default:
        break;
    }
  };

  const onQCSave = (checked: boolean, comment: string) => {
    setShowQCAssessmentDialog(false);
    onCreateTurbineDataQCAssessment(turbinePath, checked, comment);
  };

  useEffect(() => {
    if (!isPublishing) {
      setShowPublishModal(false);
    }
  }, [isPublishing]);

  const menu = (
    <Menu onClick={onClick}>
      {canPublish && <Menu.Item key={MenuOptions.Publish}>Publish to portal</Menu.Item>}
      <Menu.Item disabled={loadingDataQCAssessment || !canAnnotate} key={MenuOptions.QCAssessment}>
        Data QC Assessment
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div className={styles.turbineAction}>
        <Dropdown overlay={menu} placement='bottomRight' openClassName={styles.openDropdown} trigger={['click']}>
          <a className={classNames('ant-dropdown-link', styles.turbineActionLink)} style={{ zIndex: 15 }} onClick={e => e.preventDefault()}>
            <EllipsisOutlined style={{ fontSize: '30px' }} />
          </a>
        </Dropdown>
      </div>
      <PublishModal
        showModal={showPulishModal}
        standard={standard}
        selectedTurbineIds={[turbinePath]}
        data={[{ key: turbinePath, standardId: standard?.id }]}
        isPublishing={isPublishing}
        onHideModal={() => setShowPublishModal(false)}
        onSubmit={onPublishAnnotations}
      />
      <DataQCAssessmentModal
        dataQCAssessment={turbineDataQCAssessment}
        showModal={showQCAssessmentDialog}
        onSave={onQCSave}
        closeModal={() => setShowQCAssessmentDialog(false)}
        isLoading={creatingDataQCAssessment}
        isTurbineQC={true}
      />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  isPublishing: state.annotation.isPublishing,
  turbineDataQCAssessment: state.qc.dataQCAssessment,
  loadingDataQCAssessment: state.qc.loadingDataQCAssessment,
  creatingDataQCAssessment: state.qc.creatingDataQCAssessment,
  turbineStatusInfo: state.turbineStatus.turbineStatusInfo,
  canAnnotate: state.annotation.havePermissionToAnnotate,
  canPublish: state.annotation.canPublish,
  standard: state.annotation.annotationStandardDetails
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onPublishAnnotations: (request: PublishRequest) => dispatch(publishSingleTurbine(request)),
  onCreateTurbineDataQCAssessment: (turbinePath: string, haveQC: boolean, comment: string) =>
    dispatch(createTurbineDataQCAssessment(turbinePath, haveQC, comment))
});

export default connect(mapStateToProps, mapDispatchToProps)(TurbineActions);
